import React from 'react';
import { Box, Typography, Checkbox, FormControlLabel, Stack, Button, RadioGroup, Radio } from '@mui/material';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { SmallFormDateField } from '../../../components/small-fields/SmallFormDateField';
import { formatDate } from '../../../services/functions';
import { useApplication } from './ApplicationsContext';
import { filter } from 'lodash';

export const ApplicationsFilter = ({ setData }) => {
  const { setFiltersParams, choices } = useApplication();

  const [filters, setFilters] = React.useState({
    state: [],
    function_type: [],
    additional_qualifications: [],
    range_of_skills: [],
    periods_type: [],
    periods: [],
    ol_periods: [],
    zs_periods: [],
    is_bonus: false,
    resort: 'all',
    resort_declared: 'all',
    zs_date_from: null,
    zs_date_to: null,
    date_from: null,
    date_to: null,
    signing_date_from: null,
    signing_date_to: null,
    birth_date_from: null,
    birth_date_to: null,
    is_agreement_not_send_to_dgcs: false,
    unsent_documents: [],
    unreturned_documents: [],
    issued_documents: [],
    consents: []
  });

  const resetFilters = () => {
    setFilters({
      state: [],
      function_type: [],
      additional_qualifications: [],
      range_of_skills: [],
      periods_type: [],
      periods: [],
      ol_periods: [],
      zs_periods: [],
      is_bonus: false,
      resort_declared: 'all',
      zs_date_from: null,
      zs_date_to: null,
      date_from: null,
      date_to: null,
      birth_date_from: null,
      birth_date_to: null,
      is_agreement_not_send_to_dgcs: false,
      unsent_documents: [],
      unreturned_documents: [],
      issued_documents: [],
      consents: []

    });
  };

  React.useEffect(() => {
    const params = new URLSearchParams();

    for (const property in filters) {
      if (filters.hasOwnProperty(property) && filters[property] !== null && filters[property] !== '') {
        if (Array.isArray(filters[property])) {
          filters[property].forEach(value => params.append(property, value));
        } else {
          params.append(property, filters[property]);
        }
      }
    }


    setFiltersParams(params.toString());

  }, [filters]);

  const handleChangeState = value => {
    if (filters.state.includes(value)) {
      setFilters(prev => ({ ...prev, state: prev.state.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, state: [...prev.state, value] }));
    }
  };

  const handleChangeStateALL = e => {
    if (e.target.checked) {
      setFilters({ ...filters, state: ['NEW', 'ARR', 'AGS', 'REJ', 'RGN', 'FOU', 'ALL', 'SAG'] });
    } else {
      setFilters({ ...filters, state: [] });
    }
  };

  const handleChangeFunction = value => {
    if (filters.function_type.includes(value)) {
      setFilters(prev => ({ ...prev, function_type: prev.function_type.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, function_type: [...prev.function_type, value] }));
    }
  };

  const handleChangeFunctionALL = e => {
    if (e.target.checked) {
      setFilters({ ...filters, function_type: choices.function_type?.map(item => item.value) });
    } else {
      setFilters({ ...filters, function_type: [] });
    }
  };

  const handleChangeArray = (value, name) => {
    if (filters[name].includes(value)) {
      setFilters(prev => ({ ...prev, [name]: prev[name].filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, [name]: [...prev[name], value] }));
    }
  };

  const handleChangeArrayALL = (e, name) => {
    if (e.target.checked) {
      setFilters({ ...filters, [name]: choices[name]?.map(item => item.value) });
    } else {
      setFilters({ ...filters, [name]: [] });
    }
  };

  const handleChangePeriods = value => {
    if (filters.periods.includes(value)) {
      setFilters(prev => ({ ...prev, periods: prev.periods.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, periods: [...prev.periods, value] }));
    }
  };

  const handleChangePeriodsOL = value => {
    if (filters.ol_periods.includes(value)) {
      setFilters(prev => ({ ...prev, ol_periods: prev.ol_periods.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, ol_periods: [...prev.ol_periods, value] }));
    }
  };

  const handleChangePeriodsZS = value => {
    if (filters.zs_periods.includes(value)) {
      setFilters(prev => ({ ...prev, zs_periods: prev.zs_periods.filter(val => val !== value) }));
    } else {
      setFilters(prev => ({ ...prev, zs_periods: [...prev.zs_periods, value] }));
    }
  };


  const handleChangeDocumentsAll = (e, name) => {
    if (e.target.checked) {
      setFilters({ ...filters, [name]:
        // nazwy musza odpowiadać początkowi identifier checboxitems
        [
          'umowa', 'aneks', 'kwestionariusz', 'ppk', 'oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania',
          'legitymacja', 'oswiadczenie_studenta', 'rezygnacja_ppk'
        ] });
    } else {
      setFilters({ ...filters, [name]: [] });
    }
  };


  return <Box sx = {{ width: '95%' }}>
    <Stack direction="row" justifyContent="space-between" alignItems="baseline">
      <Typography variant="h6" sx={{ mb: 2 }}>Filtry</Typography>
      <Button onClick={resetFilters}>Resetuj</Button>
    </Stack>
    <TreeView
      defaultExpanded={[]}
      defaultCollapseIcon={<ExpandMoreIcon />}
      defaultExpandIcon={<ChevronRightIcon />}
      defaultEndIcon={null}
    >
      <TreeItem nodeId="1" label={ <FormControlLabel
        label="Status"
        control={
          <Checkbox
            onChange={handleChangeStateALL}
            onClick={e => e.stopPropagation()}
            checked={filters.state.length === 8}
            indeterminate={filters.state.length < 8 && filters.state.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          <FormControlLabel
            label="Nowy"
            control={<Checkbox
              checked={filters.state.includes('NEW')}
              onChange={() => handleChangeState('NEW')}
              sx={
                {
                  color: '#0CAFFF',
                  '&.Mui-checked': {
                    color: '#0CAFFF'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Ustalenia"
            control={<Checkbox
              checked={filters.state.includes('ARR')}
              onChange={() => handleChangeState('ARR')}
              sx={
                {
                  color: '#FFC107',
                  '&.Mui-checked': {
                    color: '#FFC107'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Wysłana umowa"
            control={<Checkbox
              checked={filters.state.includes('AGS')}
              onChange={() => handleChangeState('AGS')}
              sx={
                {
                  color: '#004320',
                  '&.Mui-checked': {
                    color: '#004320'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Wysłany aneks"
            control={<Checkbox
              checked={filters.state.includes('ANS')}
              onChange={() => handleChangeState('ANS')}
              sx={
                {
                  color: '#448764',
                  '&.Mui-checked': {
                    color: '#448764'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Wysłać umowe"
            control={<Checkbox
              checked={filters.state.includes('SAG')}
              onChange={() => handleChangeState('SAG')}
              sx={
                {
                  color: '#ff5f1f',
                  '&.Mui-checked': {
                    color: '#ff5f1f'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Umowa poza systemem"
            control={<Checkbox
              checked={filters.state.includes('AOS')}
              onChange={() => handleChangeState('AOS')}
              sx={
                {
                  color: '#74dd21',
                  '&.Mui-checked': {
                    color: '#74dd21'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Rezygnacja"
            control={<Checkbox
              checked={filters.state.includes('RGN')}
              onChange={() => handleChangeState('RGN')}
              sx={
                {
                  color: 'gray',
                  '&.Mui-checked': {
                    color: 'gray'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Rezygnacja kandydata"
            control={<Checkbox
              checked={filters.state.includes('CRG')}
              onChange={() => handleChangeState('CRG')}
              sx={
                {
                  color: 'black',
                  '&.Mui-checked': {
                    color: 'black'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Odrzucony"
            control={<Checkbox
              checked={filters.state.includes('REJ')}
              onChange={() => handleChangeState('REJ')}
              sx={
                {
                  color: '#FF00BF',
                  '&.Mui-checked': {
                    color: '#FF00BF'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="FINAL OUT"
            control={<Checkbox
              checked={filters.state.includes('FOU')}
              onChange={() => handleChangeState('FOU')}
              sx={
                {
                  color: '#960018',
                  '&.Mui-checked': {
                    color: '#960018'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="Umowa odesłana"
            control={<Checkbox
              checked={filters.state.includes('ALL')}
              onChange={() => handleChangeState('ALL')}
              sx={
                {
                  color: '#662d91',
                  '&.Mui-checked': {
                    color: '#662d91'
                  }
                }
              }/>}
          />
          <FormControlLabel
            label="E-umowa odesłana"
            control={<Checkbox
              checked={filters.state.includes('EAS')}
              onChange={() => handleChangeState('EAS')}
              sx={
                {
                  color: '#cc8fe7',
                  '&.Mui-checked': {
                    color: '#cc8fe7'
                  }
                }
              }/>}
          />
        </Stack>
      </TreeItem>
      <TreeItem nodeId="8" label={ <FormControlLabel
        label="Rodzaj terminów"
        control={
          <Checkbox
            onChange={e => handleChangeArrayALL(e, 'periods_type')}
            onClick={e => e.stopPropagation()}
            checked={filters.periods_type.length === choices.periods_type?.length}
            indeterminate={filters.periods_type.length < choices.periods_type?.length && filters.periods_type.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {choices.periods_type?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.periods_type.includes(item.value)}
                onChange={() => handleChangeArray(item.value, 'periods_type')}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="2" label={ <FormControlLabel
        label="Funkcja"
        control={
          <Checkbox
            onChange={handleChangeFunctionALL}
            onClick={e => e.stopPropagation()}
            checked={filters.function_type.length === choices.function_type?.length}
            indeterminate={filters.function_type.length < choices.function_type?.length && filters.function_type.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {/* {choices.function_type?.map(item => item.label === 'pracownik gastronomiczny' || item.label === 'pracownik socjalny' ? null : ( */}
          {choices.function_type?.map(item => item.label === 'pracownik socjalny' ? null : (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.function_type.includes(item.value)}
                onChange={() => handleChangeFunction(item.value)}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="3" label={ <FormControlLabel
        label="Uprawnienia"
        control={
          <Checkbox
            onChange={e => handleChangeArrayALL(e, 'additional_qualifications')}
            onClick={e => e.stopPropagation()}
            checked={filters.additional_qualifications.length === choices.additional_qualifications?.length}
            indeterminate={filters.additional_qualifications.length < choices.additional_qualifications?.length && filters.additional_qualifications.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {choices.additional_qualifications?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.additional_qualifications.includes(item.value)}
                onChange={() => handleChangeArray(item.value, 'additional_qualifications')}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="4" label={ <FormControlLabel
        label="Zakres umiejętności"
        control={
          <Checkbox
            onChange={e => handleChangeArrayALL(e, 'range_of_skills')}
            onClick={e => e.stopPropagation()}
            checked={filters.range_of_skills.length === choices.range_of_skills?.length}
            indeterminate={filters.range_of_skills.length < choices.range_of_skills?.length && filters.range_of_skills.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {choices.range_of_skills?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.range_of_skills.includes(item.value)}
                onChange={() => handleChangeArray(item.value, 'range_of_skills')}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="5" label={ <FormControlLabel
        label="Impreza"
        control={
          <Checkbox
            onChange={e => handleChangeArrayALL(e, 'periods_type')}
            onClick={e => e.stopPropagation()}
            checked={filters.periods_type.length === choices.periods_type?.length}
            indeterminate={filters.periods_type.length < choices.periods_type?.length && filters.periods_type.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {choices.periods_type?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.periods_type.includes(item.value)}
                onChange={() => handleChangeArray(item.value, 'periods_type')}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="6" label={ <FormControlLabel
        label="Bonus"
        control={
          <Checkbox
            onChange={e => setFilters(prev => ({ ...prev, is_bonus: e.target.checked }))}
            checked={filters.is_bonus}
          />
        }
      /> }>
      </TreeItem>
      <TreeItem nodeId="6" label={ <FormControlLabel
        label="Posiada niezwrócone dokumenty podpisane elektronicznie"
        control={
          <Checkbox
            onChange={e => setFilters(prev => ({ ...prev, is_agreement_not_send_to_dgcs: e.target.checked }))}
            checked={filters.is_agreement_not_send_to_dgcs}
          />
        }
      /> }>
      </TreeItem>
      <TreeItem nodeId="7" label={<Typography style={{ padding: 8 }}>Data urodzenia</Typography>}>
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="birth_date_from"
          type="text"
          label="Data urodzenia od"
          variant="standard"
          value={filters.birth_date_from}
          onChange={val => setFilters({ ...filters, birth_date_from: formatDate(val) })}
        />
        <SmallFormDateField
          sx = {{ width: '100%', mb: 2 }}
          name="birth_date_to"
          type="text"
          label="Data urodzenia do"
          variant="standard"
          value={filters.birth_date_to}
          onChange={val => setFilters({ ...filters, birth_date_to: formatDate(val) })}
        />
      </TreeItem>
      <TreeItem nodeId="8" label={<Typography style={{ padding: 8 }}>Ośrodek - zatrudnienie</Typography>}>
        <RadioGroup
          value={filters.resort}
          onChange={event => setFilters(prev => ({ ...prev, resort: event.target.value }))}
          sx={{ pl: '18px' }}
        >
          <FormControlLabel value="all" control={<Radio />} label="Wszystkie" />
          <FormControlLabel value="giewartow" control={<Radio />} label="GIEWARTÓW" />
          <FormControlLabel value="mrowki" control={<Radio />} label="MRÓWKI" />
        </RadioGroup>
      </TreeItem>
      <TreeItem nodeId="9" label={<Typography style={{ padding: 8 }}>Ośrodek - deklarowany termin</Typography>}>
        <RadioGroup
          value={filters.resort_declared}
          onChange={event => setFilters(prev => ({ ...prev, resort_declared: event.target.value }))}
          sx={{ pl: '18px' }}
        >
          <FormControlLabel value="all" control={<Radio />} label="Wszystkie" />
          <FormControlLabel value="giewartow" control={<Radio />} label="GIEWARTÓW" />
          <FormControlLabel value="mrowki" control={<Radio />} label="MRÓWKI" />
        </RadioGroup>
      </TreeItem>
      <TreeItem nodeId="10" label={<Typography style={{ padding: 8 }}>Termin zadeklarowany</Typography>}>
        <Stack sx={{ pl: '18px' }}>
          {choices.ol_periods?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              sx={{ mt: '10px' }}
              control={<Checkbox
                checked={filters.periods.includes(item.value)}
                onChange={() => handleChangePeriods(item.value)}
              />}
            />
          ))}
          {choices.zs_periods?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              sx={{ mt: '10px' }}
              control={<Checkbox
                checked={filters.periods.includes(item.value)}
                onChange={() => handleChangePeriods(item.value)}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="11" label={<Typography style={{ padding: 8 }}>Termin zatrudniony w obozach</Typography>}>
        <Stack sx={{ pl: '18px' }}>
          {choices.ol_periods?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              sx={{ mt: '10px' }}
              control={<Checkbox
                checked={filters.ol_periods.includes(item.value)}
                onChange={() => handleChangePeriodsOL(item.value)}
              />}
            />
          ))}
        </ Stack>
      </TreeItem>
      <TreeItem nodeId="12" label={<Typography style={{ padding: 8 }}>Termin zatrudniony w zielonych szkołach</Typography>}>
        <Stack sx={{ pl: '18px' }}>
          {choices.zs_periods?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              sx={{ mt: '10px' }}
              control={<Checkbox
                checked={filters.zs_periods.includes(item.value)}
                onChange={() => handleChangePeriodsZS(item.value)}
              />}
            />
          ))}
        </ Stack>
      </TreeItem>
      <TreeItem nodeId="13" label={<Typography style={{ padding: 8 }}>Terminy ZS</Typography>}>
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="zs_date_from"
          type="text"
          label="Termin od"
          variant="standard"
          value={filters.zs_date_from}
          onChange={val => setFilters({ ...filters, zs_date_from: formatDate(val) })}
        />
        <SmallFormDateField
          sx = {{ width: '100%', mb: 2 }}
          name="zs_date_to"
          type="text"
          label="Termin do"
          variant="standard"
          value={filters.zs_date_to}
          onChange={val => setFilters({ ...filters, zs_date_to: formatDate(val) })}
        />
      </TreeItem>
      <TreeItem nodeId="14" label={<Typography style={{ padding: 8 }}>Termin umowy</Typography>}>
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="date_from"
          type="text"
          label="Termin od"
          variant="standard"
          value={filters.date_from}
          onChange={val => setFilters({ ...filters, date_from: formatDate(val) })}
        />
        <SmallFormDateField
          sx = {{ width: '100%', mb: 2 }}
          name="date_to"
          type="text"
          label="Termin do"
          variant="standard"
          value={filters.date_to}
          onChange={val => setFilters({ ...filters, date_to: formatDate(val) })}
        />
      </TreeItem>
      <TreeItem nodeId="15" label={<Typography style={{ padding: 8 }}>Data podpisania umowy</Typography>}>
        <SmallFormDateField
          sx={{ width: '100%', mb: 2 }}
          name="signing_date_from"
          type="text"
          label="Data od"
          variant="standard"
          value={filters.signing_date_from}
          onChange={val => setFilters({ ...filters, signing_date_from: formatDate(val) })}
        />
        <SmallFormDateField
          sx = {{ width: '100%', mb: 2 }}
          name="signing_date_to"
          type="text"
          label="Data do"
          variant="standard"
          value={filters.signing_date_to}
          onChange={val => setFilters({ ...filters, signing_date_to: formatDate(val) })}
        />
      </TreeItem>
      <TreeItem nodeId="16" label={ <FormControlLabel
        label="Dokumenty wystawione"
        control={
          <Checkbox
            onChange={e => handleChangeDocumentsAll(e, 'issued_documents')}
            onClick={e => e.stopPropagation()}
            checked={filters.issued_documents.length === 8}
            indeterminate={filters.issued_documents.length < 8 && filters.issued_documents.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          <FormControlLabel
            key={'umowa'}
            label={'Umowa'}
            control={<Checkbox
              checked={filters.issued_documents.includes('umowa')}
              onChange={() => handleChangeArray('umowa', 'issued_documents')}
            />}
          />
          <FormControlLabel
            key={'annex_unsent'}
            label={'Aneks'}
            control={<Checkbox
              checked={filters.issued_documents.includes('aneks')}
              onChange={() => handleChangeArray('aneks', 'issued_documents')}
            />}
          />
          <FormControlLabel
            key={'kwestionariusz'}
            label={'Kwestionariusz'}
            control={<Checkbox
              checked={filters.issued_documents.includes('kwestionariusz')}
              onChange={() => handleChangeArray('kwestionariusz', 'issued_documents')}
            />}
          />
          <FormControlLabel
            key={'PPK'}
            label={'Informacja PPK'}
            control={<Checkbox
              checked={filters.issued_documents.includes('ppk')}
              onChange={() => handleChangeArray('ppk', 'issued_documents')}
            />}
          />
          <FormControlLabel
            key={'oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania'}
            label={'Oświadczenie o obywatelstwie'}
            control={<Checkbox
              checked={filters.issued_documents.includes('oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania')}
              onChange={() => handleChangeArray('oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania', 'issued_documents')}
            />}
          />
          <FormControlLabel
            key={'legitymacja'}
            label={'Legitymacja'}
            control={<Checkbox
              checked={filters.issued_documents.includes('legitymacja')}
              onChange={() => handleChangeArray('legitymacja', 'issued_documents')}
            />}
          />
          <FormControlLabel
            key={'oswiadczenie_studenta'}
            label={'Oświadczenie studenta'}
            control={<Checkbox
              checked={filters.issued_documents.includes('oswiadczenie_studenta')}
              onChange={() => handleChangeArray('oswiadczenie_studenta', 'issued_documents')}
            />}
          />
          <FormControlLabel
            key={'rezygnacja_ppk'}
            label={'Rezygnacja ppk'}
            control={<Checkbox
              checked={filters.issued_documents.includes('rezygnacja_ppk')}
              onChange={() => handleChangeArray('rezygnacja_ppk', 'issued_documents')}
            />}
          />
          <FormControlLabel
            key={'oświadczenie_PIT'}
            label={'Oświadczenie PIT'}
            control={<Checkbox
              checked={filters.issued_documents.includes('oświadczenie_PIT')}
              onChange={() => handleChangeArray('oświadczenie_PIT', 'issued_documents')}
            />}
          />
        </Stack>
      </TreeItem>
      <TreeItem nodeId="17" label={ <FormControlLabel
        label="Dokumenty niewysłane"
        control={
          <Checkbox
            onChange={e => handleChangeDocumentsAll(e, 'unsent_documents')}
            onClick={e => e.stopPropagation()}
            checked={filters.unsent_documents.length === 8}
            indeterminate={filters.unsent_documents.length < 8 && filters.unsent_documents.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          <FormControlLabel
            key={'umowa'}
            label={'Umowa'}
            control={<Checkbox
              checked={filters.unsent_documents.includes('umowa')}
              onChange={() => handleChangeArray('umowa', 'unsent_documents')}
            />}
          />
          <FormControlLabel
            key={'annex_unsent'}
            label={'Aneks'}
            control={<Checkbox
              checked={filters.unsent_documents.includes('aneks')}
              onChange={() => handleChangeArray('aneks', 'unsent_documents')}
            />}
          />
          <FormControlLabel
            key={'kwestionariusz'}
            label={'Kwestionariusz'}
            control={<Checkbox
              checked={filters.unsent_documents.includes('kwestionariusz')}
              onChange={() => handleChangeArray('kwestionariusz', 'unsent_documents')}
            />}
          />
          <FormControlLabel
            key={'PPK'}
            label={'Informacja PPK'}
            control={<Checkbox
              checked={filters.unsent_documents.includes('ppk')}
              onChange={() => handleChangeArray('ppk', 'unsent_documents')}
            />}
          />
          <FormControlLabel
            key={'oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania'}
            label={'Oświadczenie o obywatelstwie'}
            control={<Checkbox
              checked={filters.unsent_documents.includes('oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania')}
              onChange={() => handleChangeArray('oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania', 'unsent_documents')}
            />}
          />
          <FormControlLabel
            key={'legitymacja'}
            label={'Legitymacja'}
            control={<Checkbox
              checked={filters.unsent_documents.includes('legitymacja')}
              onChange={() => handleChangeArray('legitymacja', 'unsent_documents')}
            />}
          />
          <FormControlLabel
            key={'oswiadczenie_studenta'}
            label={'Oświadczenie studenta'}
            control={<Checkbox
              checked={filters.unsent_documents.includes('oswiadczenie_studenta')}
              onChange={() => handleChangeArray('oswiadczenie_studenta', 'unsent_documents')}
            />}
          />
          <FormControlLabel
            key={'rezygnacja_ppk'}
            label={'Rezygnacja ppk'}
            control={<Checkbox
              checked={filters.unsent_documents.includes('rezygnacja_ppk')}
              onChange={() => handleChangeArray('rezygnacja_ppk', 'unsent_documents')}
            />}
          />
        </Stack>
      </TreeItem>

      <TreeItem nodeId="18" label={ <FormControlLabel
        label="Dokumenty niezwrócone"
        control={
          <Checkbox
            onChange={e => handleChangeDocumentsAll(e, 'unreturned_documents')}
            onClick={e => e.stopPropagation()}
            checked={filters.unreturned_documents.length === 8}
            indeterminate={filters.unreturned_documents.length < 8 && filters.unreturned_documents.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          <FormControlLabel
            key={'umowa'}
            label={'Umowa'}
            control={<Checkbox
              checked={filters.unreturned_documents.includes('umowa')}
              onChange={() => handleChangeArray('umowa', 'unreturned_documents')}
            />}
          />
          <FormControlLabel
            key={'annex_unsent'}
            label={'Aneks'}
            control={<Checkbox
              checked={filters.unreturned_documents.includes('aneks')}
              onChange={() => handleChangeArray('aneks', 'unreturned_documents')}
            />}
          />
          <FormControlLabel
            key={'kwestionariusz'}
            label={'Kwestionariusz'}
            control={<Checkbox
              checked={filters.unreturned_documents.includes('kwestionariusz')}
              onChange={() => handleChangeArray('kwestionariusz', 'unreturned_documents')}
            />}
          />
          <FormControlLabel
            key={'PPK'}
            label={'Informacja PPK'}
            control={<Checkbox
              checked={filters.unreturned_documents.includes('ppk')}
              onChange={() => handleChangeArray('ppk', 'unreturned_documents')}
            />}
          />
          <FormControlLabel
            key={'oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania'}
            label={'Oświadczenie o obywatelstwie'}
            control={<Checkbox
              checked={filters.unreturned_documents.includes('oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania')}
              onChange={() => handleChangeArray('oświadczenie_o_obywatelstwie-i-miejscu-zamieszkania', 'unreturned_documents')}
            />}
          />
          <FormControlLabel
            key={'legitymacja'}
            label={'Legitymacja'}
            control={<Checkbox
              checked={filters.unreturned_documents.includes('legitymacja')}
              onChange={() => handleChangeArray('legitymacja', 'unreturned_documents')}
            />}
          />
          <FormControlLabel
            key={'oswiadczenie_studenta'}
            label={'Oświadczenie studenta'}
            control={<Checkbox
              checked={filters.unreturned_documents.includes('oswiadczenie_studenta')}
              onChange={() => handleChangeArray('oswiadczenie_studenta', 'unreturned_documents')}
            />}
          />
          <FormControlLabel
            key={'rezygnacja_ppk'}
            label={'Rezygnacja ppk'}
            control={<Checkbox
              checked={filters.unreturned_documents.includes('rezygnacja_ppk')}
              onChange={() => handleChangeArray('rezygnacja_ppk', 'unreturned_documents')}
            />}
          />
          {/* <FormControlLabel
            key={'oświadczenie_PIT'}
            label={'Oświadczenie PIT'}
            control={<Checkbox
              checked={filters.unreturned_documents.includes('oświadczenie_PIT')}
              onChange={() => handleChangeArray('oświadczenie_PIT', 'unreturned_documents')}
            />}
          /> */}
        </Stack>
      </TreeItem>
      <TreeItem nodeId="19" label={ <FormControlLabel
        label="Zgody"
        control={
          <Checkbox
            onChange={e => handleChangeArrayALL(e, 'consents')}
            onClick={e => e.stopPropagation()}
            checked={filters.consents.length === choices.consents?.length}
            indeterminate={filters.consents.length < choices.consents?.length && filters.consents.length > 0}
          />
        }
      /> }>
        <Stack sx={{ pl: '18px' }}>
          {choices.consents?.map(item => (
            <FormControlLabel
              key={item.value}
              label={item.label}
              control={<Checkbox
                checked={filters.consents.includes(item.value)}
                onChange={() => handleChangeArray(item.value, 'consents')}
              />}
            />
          ))}
        </Stack>
      </TreeItem>
    </TreeView>

  </Box>;

};

export default ApplicationsFilter;
